import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import LeaveView from './view/LeaveView';
import LeaveDetails from './details/LeaveDetails';

import buttons from './LeaveButtons';
import events from './LeaveEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('leave'),
	routes: [
		{
			path: 'leave/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'leave'),
			element: (
				<DetailsPage
					key="leave/add"
					module="leave"
					headerOptions={{ showAvatar: true }}
					tabs={LeaveDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},

		{
			path: 'leave/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'leave'),
			element: (
				<DetailsPage
					key="leave/details"
					module="leave"
					headerOptions={{ showAvatar: true }}
					tabs={LeaveDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'leave/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'leave'),
			element: (
				<ViewPage
					key="leave/view"
					module="leave"
					content={{ type: 'tabs', tabs: LeaveView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
